import { EmptyStructuredQuery } from '../../../core/query/entities/empty-structured-query.constant';
import { StructuredQuery } from '../../../core/query/entities/structured-query.entity';
import { ShSelectedFacetValue } from '../../../elements/components/facet/entities/facet.entity';
import { DisplayMode } from '../../generic-overview/components/display-settings-bar/entities/display-mode.entity';
import { SortInfo } from '../../generic-overview/components/display-settings-bar/entities/sort-info.entity';
import { defaultPaginationInfo } from '../../generic-overview/components/pagination/entities/pagination-info.entity';

export interface UrlQueryState {
    structuredQuery: StructuredQuery;
    selectedFacets: ShSelectedFacetValue[];
    sortInfo?: SortInfo;
    view?: DisplayMode;
    page: number;
    pageSize?: number;
}

export interface PartialSearchPageState extends UrlQueryState {
    panelStates: Record<string, boolean>;
    selectedItemIds: string[];
}

export interface SearchPageState extends PartialSearchPageState {
    sortInfo: SortInfo;
    view: DisplayMode;
    page: number;
    pageSize: number;
}

export const EmptyUrlQueryState: UrlQueryState = {
    structuredQuery: EmptyStructuredQuery,
    selectedFacets: [],
    sortInfo: undefined,
    view: undefined,
    page: defaultPaginationInfo.page,
    pageSize: defaultPaginationInfo.resultsPerPage
};

export interface PartialSearchState {
    structuredQuery: StructuredQuery;
    page: number;
    pageSize?: number;
    sortInfo?: SortInfo;
    view?: DisplayMode;
}
export interface SearchState extends PartialSearchState {
    pageSize: number;
    sortInfo: SortInfo;
    view: DisplayMode;
}

export enum Panel {
    FILTERS = 'filters',
    HIERARCHY = 'hierarchy',
    DETAIL = 'detail'
}
